import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

// Bold "B" glyph for the message text-styles toolbar (not a Figma icon
// export; drawn to match the 24-viewBox stroke icons in this set).
export const BoldIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

BoldIcon.displayName = 'BoldIcon';
